import { roles } from '@/helpers/variables';
import i18n from '@/i18n';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const snakeKeysObjectDeep = require('snakecase-keys');

export function toSnakeCase(data, type = 'object') {
  let payload = type === 'object' ? {} : [];
  Object.entries(data).forEach(e => {
    // eslint-disable-next-line no-unused-vars
    const [key, value] = e;
    if (type === 'object') {
      payload = snakeKeysObjectDeep(data);
    } else {
      payload.push(snakeKeysObjectDeep(value));
    }

  });
  return payload;
}

export const isMobile = {
  Android: function() {
    return !!navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
    return !!navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function() {
    return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Windows: function() {
    return !!navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows());
  }
};

export function calculateAspectRatioFit({ width, height, maxWidth, maxHeight }) {
  const ratio = Math.min(maxWidth / width, maxHeight / height);
  return {
    width: width * ratio,
    height: height * ratio
  };
}


export const ROLES = [
  {
    id: roles.ADMIN.toString(),
    name: i18n.global.t('admin')
  },
  {
    id: roles.SUPPORT.toString(),
    name: i18n.global.t('support')
  }
];

export const sectorTypes = {
  en: [
    {
      'id': 0,
      'name': 'Other',
      'categories': []
    },
    {
      'id': 1,
      'name': 'electronics & gadgets',
      'categories': [
        'Mobile phones & accessories',
        'Computers & laptops',
        'Audio devices',
        'Wearable tech'
      ]
    },
    {
      'id': 2,
      'name': 'Fashion & Apparel',
      'categories': [
        'Men\'s clothing',
        'Women\'s clothing',
        'Kid\'s clothing',
        'Footwear',
        'Accessories (watches, jewelry, sunglasses, etc.)'
      ]
    },
    {
      'id': 3,
      'name': 'Home & Living',
      'categories': [
        'Furniture',
        'Home decor',
        'Kitchen appliances',
        'Garden supplies'
      ]
    },
    {
      'id': 4,
      'name': 'Beauty & Health & Personal Care',
      'categories': [
        'Cosmetics',
        'Skincare',
        'Haircare',
        'Nutritional supplements',
        'Fitness equipment',
        'Perfumes & fragrances'
      ]
    },
    {
      'id': 5,
      'name': 'Food & Beverages',
      'categories': [
        'Packaged food',
        'Beverages (alcoholic & non-alcoholic)',
        'Organic products',
        'Gourmet & specialty foods'
      ]
    },
    {
      'id': 6,
      'name': 'Books & Stationery',
      'categories': [
        'Novels',
        'Educational books',
        'Art supplies',
        'Office supplies'
      ]
    },
    {
      'id': 7,
      'name': 'Toys & Entertainment',
      'categories': [
        'Toys & games for children',
        'Video games',
        'Music instruments',
        'Hobby kits'
      ]
    },
    {
      'id': 8,
      'name': 'Sports & Outdoor',
      'categories': [
        'Sports equipment',
        'Camping & hiking gear',
        'Cycling',
        'Water sports'
      ]
    },
    {
      'id': 9,
      'name': 'Automotive & Industrial',
      'categories': [
        'Car accessories',
        'Industrial tools',
        'Machinery'
      ]
    },
    {
      'id': 10,
      'name': 'Arts & Crafts',
      'categories': [
        'Handmade items',
        'Craft supplies',
        'Collectibles'
      ]
    },
    {
      'id': 11,
      'name': 'Automotive',
      'categories': [
        'New car sales',
        'Used car sales',
        'Motorcycles & scooters',
        'Electric & hybrid vehicles',
        'Automotive parts & accessories'
      ]
    },
    {
      'id': 12,
      'name': 'Health & Pharmaceuticals',
      'categories': [
        'Over-the-counter medicines',
        'Prescription drugs',
        'Herbal remedies & supplements',
        'Medical equipment & devices',
        'Health & wellness products (e.g., vitamins, dietary supplements)'
      ]
    }
  ],
  es: [
    {
      'id': 0,
      'name': 'Otros',
      'categories': []
    },
    {
      'id': 1,
      'name': 'Electrónicos y gadgets',
      'categories': [
        'Teléfonos móviles y accesorios',
        'Ordenadores y portátiles',
        'Dispositivos de audio',
        'Tecnología portátil'
      ]
    },
    {
      'id': 2,
      'name': 'Moda y Ropa',
      'categories': [
        'Ropa de hombre',
        'Ropa de mujer',
        'Ropa de niños',
        'Calzado',
        'Accesorios (relojes, joyería, gafas de sol, etc.)'
      ]
    },
    {
      'id': 3,
      'name': 'Hogar y Vida',
      'categories': [
        'Muebles',
        'Decoración del hogar',
        'Electrodomésticos de cocina',
        'Suministros de jardín'
      ]
    },
    {
      'id': 4,
      'name': 'Salud, Belleza y Cuidado Personal',
      'categories': [
        'Cosméticos',
        'Cuidado de la piel',
        'Cuidado del cabello',
        'Suplementos nutricionales',
        'Equipo de fitness',
        'Perfumes y fragancias'
      ]
    },
    {
      'id': 5,
      'name': 'Alimentos y Bebidas',
      'categories': [
        'Alimentos envasados',
        'Bebidas (alcohólicas y no alcohólicas)',
        'Productos orgánicos',
        'Alimentos gourmet y especialidades'
      ]
    },
    {
      'id': 6,
      'name': 'Libros y Papelería',
      'categories': [
        'Novelas',
        'Libros educativos',
        'Suministros de arte',
        'Suministros de oficina'
      ]
    },
    {
      'id': 7,
      'name': 'Juguetes y Entretenimiento',
      'categories': [
        'Juguetes y juegos para niños',
        'Videojuegos',
        'Instrumentos musicales',
        'Kits de pasatiempos'
      ]
    },
    {
      'id': 8,
      'name': 'Deportes y Aire Libre',
      'categories': [
        'Equipamiento deportivo',
        'Equipamiento para acampada y senderismo',
        'Ciclismo',
        'Deportes acuáticos'
      ]
    },
    {
      'id': 9,
      'name': 'Automoción e Industrial',
      'categories': [
        'Accesorios para coches',
        'Herramientas industriales',
        'Maquinaria'
      ]
    },
    {
      'id': 10,
      'name': 'Artes y Manualidades',
      'categories': [
        'Artículos hechos a mano',
        'Suministros de manualidades',
        'Objetos de colección'
      ]
    },
    {
      'id': 11,
      'name': 'Automoción',
      'categories': [
        'Venta de coches nuevos',
        'Venta de coches usados',
        'Motos y scooters',
        'Vehículos eléctricos e híbridos',
        'Piezas y accesorios automotrices'
      ]
    },
    {
      'id': 12,
      'name': 'Salud y Farmacéuticos',
      'categories': [
        'Medicamentos sin receta',
        'Medicamentos con receta',
        'Remedios y suplementos herbales',
        'Equipamiento y dispositivos médicos',
        'Productos de salud y bienestar (por ejemplo, vitaminas, suplementos dietéticos)'
      ]
    }
  ]
};

export const chatNamesForBridge = {
  telegram: 'tg_bridge_bot',
  whatsapp: 'wa_bridge_bot'
};
export const dataForCreateBridgeWARoom = {
  initial_state: [
    {
      type: 'm.room.guest_access',
      state_key: '',
      content: {
        guest_access: 'can_join'
      }
    }
  ],
  name: chatNamesForBridge.whatsapp,
  type: 'm.room.guest_access',
  invite: [process.env.VUE_APP_WHATSAPP_BRIDGE_BOT],
  is_direct: true,
  preset: 'trusted_private_chat',
  visibility: 'private'
};

export const generateFingerprint = async () => {
  const fpPromise = await FingerprintJS.load();
  const result = await fpPromise.get();
  return result.visitorId;
};

export const dayChartDataGenerator = (from, to, month, year) => {
  const getDaysInMonth = (month, year) => new Date(year, month, 0).getDate();

  const daysInMonth = getDaysInMonth(month, year);

  return Array.from({ length: daysInMonth }, (_, day) => {
    const firstValue = Math.round(Math.random() * (to - from) + from)
    return {
      name: `${day + 1}`,
      1: firstValue,
      2: Math.round(firstValue * 1.2),
      3: Math.round(firstValue * 1.8)
    }
  });
};


export function generateRandomString(length) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charsetLength = charset.length;

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charsetLength);
    result += charset[randomIndex];
  }

  return result;
}
